import api from 'lib/api';

export const GET_LEAVE_REQUESTS = 'GET_LEAVE_REQUESTS';
export const CLEAR_LEAVE_REQUESTS = 'CLEAR_LEAVE_REQUESTS';
export const GET_LEAVE_REQUEST = 'GET_LEAVE_REQUEST';

export const getLeaveRequests = (options = {}) => ({
	type: GET_LEAVE_REQUESTS,
	payload: new Promise(resolve => {
		let queryParams = [];
		if (options.filter) queryParams.push(`filter=${encodeURIComponent(options.filter)}`);
		if (options.sortBy) queryParams.push(`sortBy=${encodeURIComponent(options.sortBy)}`);
		if (options.pageIndex !== undefined) queryParams.push(`pageIndex=${options.pageIndex}`);
		if (options.pageSize !== undefined) queryParams.push(`pageSize=${options.pageSize}`);

		const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
		api.get(`absence/leave-request${queryString}`).then((response) => {
			resolve(response.data);
		});
	}),
});

export const clearLeaveRequests = () => ({
	type: CLEAR_LEAVE_REQUESTS,
});

export const getLeaveRequest = (id) => ({
	type: GET_LEAVE_REQUEST,
	payload: new Promise(resolve => {
		api.get(`absence/leave-request/${id}`).then((response) => {
			resolve(response.data);
		});
	}),
});
